import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { STableComponent } from './meta/components/s-table/s-table.component';
import { SPagerComponent } from './meta/components/s-pager/s-pager.component';
import { SSelectorComponent } from './meta/components/s-selector/s-selector.component';
import { SDateComponent } from './meta/components/s-date/s-date/s-date.component';
import { SModalComponent } from './meta/components/s-modal/s-modal.component';
import { STreeTableComponent } from './meta/components/s-tree-table/s-tree-table.component';
import { SInputComponent } from './meta/components/s-input/s-input.component';
import {SStepsComponent} from './meta/components/s-steps/s-steps.component';
import { SLinkageComponent } from './meta/components/s-linkage/s-linkage.component';
import { SFormComponent } from './meta/components/s-form/s-form.component';
import { SAnchorComponent } from './meta/components/s-anchor/s-anchor.component';
import { SFileViewerComponent } from './meta/components/s-file-viewer/s-file-viewer.component';
import { SImgViewerComponent } from './meta/components/s-file-viewer/s-img-viewer/s-img-viewer.component';
import { SPdfViewerComponent } from './meta/components/s-file-viewer/s-pdf-viewer/s-pdf-viewer.component';
import { SUploadComponent } from './meta/components/s-upload/s-upload.component';
import { SCascaderComponent } from './meta/components/s-cascader/s-cascader.component';
import { STreeSelectComponent } from './meta/components/s-tree-select/s-tree-select.component';
import { SCheckboxGroupComponent } from './meta/components/s-checkbox-group/s-checkbox-group.component';
import { SExportCodeComponent } from './meta/components/s-export-code/s-export-code.component';
import { ZoomAndMoveDirective } from './meta/directive/zoom-and-move.directive';
import { ShareDirectiveModule } from './meta/directive/share-directive.module';
import { CodeComponent } from './meta/components/s-form/code.component';
const components = [
  STableComponent,
  SPagerComponent,
  SSelectorComponent,
  SDateComponent,
  SModalComponent,
  STreeTableComponent,
  SInputComponent,
  SStepsComponent,
  SLinkageComponent,
  SFormComponent,
  SAnchorComponent,
  SFileViewerComponent,
  SImgViewerComponent,
  SPdfViewerComponent,
  SUploadComponent,
  SCascaderComponent,
  STreeSelectComponent,
  SCheckboxGroupComponent,
  SExportCodeComponent,
  CodeComponent,
];
const directivies = [
  ZoomAndMoveDirective
];
const common = [
  CommonModule,
  NgZorroAntdModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  // ShareDirectiveModule,
];
@NgModule({
  // 只编译项目中实际使用的组件，而不是编译所有在ngModule中声明但从未使用的组件
  entryComponents: components,
  declarations: [
    ...components,
    // ...directivies,
  ],
  imports: [
    ...common,
    ShareDirectiveModule,
  ],
  exports: [
    ...common,
    ...components,
    // ...directivies,
  ]
})
export class SailingModule { }
